module.exports = __webpack_public_path__ + "img/icons B_18.8a00cfb0.png";